import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { GlobalsStore } from '../../../stores/globals.state';
import { Router } from '@angular/router';

@Component({
  selector: 'app-validation-badge',
  standalone: true,
  imports: [CommonModule, BadgeModule, ButtonModule, TooltipModule],
  template: `
    <p-button
      class="relative"
      *ngIf="invalidBookmarksCount() > 0"
      [badge]="invalidBookmarksCount().toString()"
      badgeClass="p-badge-danger absolute top-0 right-0 m-1"
      icon="fas fa-note-sticky"
      [rounded]="true"
      [pTooltip]="tooltipText()"
      tooltipPosition="bottom"
      (onClick)="openValidation()" />
  `,
  styles: [
    `
      :host {
        display: inline-block;
      }
    `,
  ],
})
export class ValidationBadgeComponent {
  readonly globalsStore = inject(GlobalsStore);
  readonly router = inject(Router);

  validationSummary = computed(() => this.globalsStore.bookmarkValidation());

  invalidBookmarksCount = computed(
    () => this.validationSummary()?.invalidBookmarks || 0
  );

  tooltipText = computed(() => {
    const summary = this.validationSummary();
    if (!summary) return '';

    const bookmarks = summary.invalidBookmarks;
    const issues = summary.totalIssues;

    return `${bookmarks} fehlerhafte Ansicht${bookmarks !== 1 ? 'en' : ''} mit ${issues} Problem${issues !== 1 ? 'en' : ''}`;
  });

  openValidation(): void {
    this.router.navigate([
      '/data-backend',
      { outlets: { overlay: 'lesezeichen' } },
    ]);
  }
}
